module.exports = __webpack_public_path__ + "static/media/Jomolhari-01.dc4015ca.svg";